import styles from "./AcMark.module.scss";

/**
 * The red AC mark — this act resolves to a band record on Artist CNTRL rather than being free text (PO,
 * 2026-08-25; broadened past friends by ART-165, so it lights for any registered band the lineup resolved).
 *
 * The brand X, inline. The spec ships it as a base64 <img>; drawn inline it stays a themeable vector coloured
 * by `--ac-color-accent` rather than a bitmap with the crimson baked in, and it keeps a real accessible name.
 *
 * Shared (ART-165): the booking rows, the owner show preview, and BOTH guest surfaces (the read-only view
 * modal and the guest editor's read-only lineup) render the SAME mark, so "on Artist CNTRL" reads identically
 * on every act everywhere it appears — the bug being fixed is that it only ever showed on the inviter's rows.
 */
const AC_MARK_POLY =
  "269 144.98 317.48 96.5 317.48 0 207.22 0 158.74 48.48 110.26 0 0 0 0 110.26 48.48 158.74 48.48 158.74 " +
  "48.48 158.74 0 207.22 0 317.48 110.26 317.48 158.74 269 207.22 317.48 317.48 317.48 317.48 220.99 269 " +
  "172.5 269 172.19 195.65 172.19 195.65 195.34 158.9 195.34 122.14 195.34 122.14 158.58 122.14 121.83 " +
  "158.9 121.83 195.65 121.83 195.65 144.98 269 144.98";

export function AcMark({ title }: { title: string }) {
  return (
    <svg className={styles.acMark} viewBox="0 0 317.48 317.48" role="img" aria-label={title}>
      <title>{title}</title>
      <polygon points={AC_MARK_POLY} />
    </svg>
  );
}
